module.exports = __webpack_public_path__ + "static/media/99gal67.0898ae9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal67.jpg
// module id = 211
// module chunks = 0